// Comprehensive list of cities worldwide organized by region for Weather Search
// Significantly expanded to include maximum viable cities per region
// Only name/city/country are required; coordinates are optional and not used for fetching.
// Keep names as commonly accepted by OpenWeather to reduce "city not found" errors.

const RANDOM_CITIES = [
  // North America (United States - Major cities by state)
  { name: "New York, NY", city: "New York", country: "US" },
  { name: "Los Angeles, CA", city: "Los Angeles", country: "US" },
  { name: "Chicago, IL", city: "Chicago", country: "US" },
  { name: "Houston, TX", city: "Houston", country: "US" },
  { name: "Phoenix, AZ", city: "Phoenix", country: "US" },
  { name: "Philadelphia, PA", city: "Philadelphia", country: "US" },
  { name: "San Antonio, TX", city: "San Antonio", country: "US" },
  { name: "San Diego, CA", city: "San Diego", country: "US" },
  { name: "Dallas, TX", city: "Dallas", country: "US" },
  { name: "San Jose, CA", city: "San Jose", country: "US" },
  { name: "Austin, TX", city: "Austin", country: "US" },
  { name: "Jacksonville, FL", city: "Jacksonville", country: "US" },
  { name: "Fort Worth, TX", city: "Fort Worth", country: "US" },
  { name: "Columbus, OH", city: "Columbus", country: "US" },
  { name: "San Francisco, CA", city: "San Francisco", country: "US" },
  { name: "Charlotte, NC", city: "Charlotte", country: "US" },
  { name: "Indianapolis, IN", city: "Indianapolis", country: "US" },
  { name: "Seattle, WA", city: "Seattle", country: "US" },
  { name: "Denver, CO", city: "Denver", country: "US" },
  { name: "Washington, D.C.", city: "Washington", country: "US" },
  { name: "Boston, MA", city: "Boston", country: "US" },
  { name: "El Paso, TX", city: "El Paso", country: "US" },
  { name: "Nashville, TN", city: "Nashville", country: "US" },
  { name: "Detroit, MI", city: "Detroit", country: "US" },
  { name: "Oklahoma City, OK", city: "Oklahoma City", country: "US" },
  { name: "Portland, OR", city: "Portland", country: "US" },
  { name: "Las Vegas, NV", city: "Las Vegas", country: "US" },
  { name: "Memphis, TN", city: "Memphis", country: "US" },
  { name: "Louisville, KY", city: "Louisville", country: "US" },
  { name: "Baltimore, MD", city: "Baltimore", country: "US" },
  { name: "Milwaukee, WI", city: "Milwaukee", country: "US" },
  { name: "Albuquerque, NM", city: "Albuquerque", country: "US" },
  { name: "Tucson, AZ", city: "Tucson", country: "US" },
  { name: "Fresno, CA", city: "Fresno", country: "US" },
  { name: "Mesa, AZ", city: "Mesa", country: "US" },
  { name: "Sacramento, CA", city: "Sacramento", country: "US" },
  { name: "Atlanta, GA", city: "Atlanta", country: "US" },
  { name: "Kansas City, MO", city: "Kansas City", country: "US" },
  { name: "Colorado Springs, CO", city: "Colorado Springs", country: "US" },
  { name: "Miami, FL", city: "Miami", country: "US" },
  { name: "Raleigh, NC", city: "Raleigh", country: "US" },
  { name: "Omaha, NE", city: "Omaha", country: "US" },
  { name: "Long Beach, CA", city: "Long Beach", country: "US" },
  { name: "Virginia Beach, VA", city: "Virginia Beach", country: "US" },
  { name: "Oakland, CA", city: "Oakland", country: "US" },
  { name: "Minneapolis, MN", city: "Minneapolis", country: "US" },
  { name: "Tulsa, OK", city: "Tulsa", country: "US" },
  { name: "Tampa, FL", city: "Tampa", country: "US" },
  { name: "Arlington, TX", city: "Arlington", country: "US" },
  { name: "New Orleans, LA", city: "New Orleans", country: "US" },
  { name: "Wichita, KS", city: "Wichita", country: "US" },
  { name: "Cleveland, OH", city: "Cleveland", country: "US" },
  { name: "Bakersfield, CA", city: "Bakersfield", country: "US" },
  { name: "Honolulu, HI", city: "Honolulu", country: "US" },
  { name: "Anaheim, CA", city: "Anaheim", country: "US" },
  { name: "Henderson, NV", city: "Henderson", country: "US" },
  { name: "Stockton, CA", city: "Stockton", country: "US" },
  { name: "Lexington, KY", city: "Lexington", country: "US" },
  { name: "Corpus Christi, TX", city: "Corpus Christi", country: "US" },
  { name: "Buffalo, NY", city: "Buffalo", country: "US" },
  { name: "Norfolk, VA", city: "Norfolk", country: "US" },
  { name: "Lincoln, NE", city: "Lincoln", country: "US" },
  { name: "Plano, TX", city: "Plano", country: "US" },
  { name: "St. Louis, MO", city: "St. Louis", country: "US" },
  { name: "Cincinnati, OH", city: "Cincinnati", country: "US" },
  { name: "Pittsburgh, PA", city: "Pittsburgh", country: "US" },
  { name: "Greensboro, NC", city: "Greensboro", country: "US" },
  { name: "Newark, NJ", city: "Newark", country: "US" },
  { name: "Anchorage, AK", city: "Anchorage", country: "US" },
  { name: "Orlando, FL", city: "Orlando", country: "US" },
  { name: "Jersey City, NJ", city: "Jersey City", country: "US" },
  { name: "Chandler, AZ", city: "Chandler", country: "US" },
  { name: "Laredo, TX", city: "Laredo", country: "US" },
  { name: "Madison, WI", city: "Madison", country: "US" },
  { name: "Durham, NC", city: "Durham", country: "US" },
  { name: "Lubbock, TX", city: "Lubbock", country: "US" },
  { name: "Winston-Salem, NC", city: "Winston-Salem", country: "US" },
  { name: "Garland, TX", city: "Garland", country: "US" },
  { name: "Glendale, AZ", city: "Glendale", country: "US" },
  { name: "Hialeah, FL", city: "Hialeah", country: "US" },
  { name: "Reno, NV", city: "Reno", country: "US" },
  { name: "Baton Rouge, LA", city: "Baton Rouge", country: "US" },
  { name: "Irvine, CA", city: "Irvine", country: "US" },
  { name: "Chesapeake, VA", city: "Chesapeake", country: "US" },
  { name: "Irving, TX", city: "Irving", country: "US" },
  { name: "Scottsdale, AZ", city: "Scottsdale", country: "US" },
  { name: "North Las Vegas, NV", city: "North Las Vegas", country: "US" },
  { name: "Fremont, CA", city: "Fremont", country: "US" },
  { name: "Gilbert, AZ", city: "Gilbert", country: "US" },
  { name: "San Bernardino, CA", city: "San Bernardino", country: "US" },
  { name: "Boise, ID", city: "Boise", country: "US" },
  { name: "Birmingham, AL", city: "Birmingham", country: "US" },

  // Canada (Major cities by province)
  { name: "Toronto, ON", city: "Toronto", country: "CA" },
  { name: "Montreal, QC", city: "Montreal", country: "CA" },
  { name: "Vancouver, BC", city: "Vancouver", country: "CA" },
  { name: "Calgary, AB", city: "Calgary", country: "CA" },
  { name: "Edmonton, AB", city: "Edmonton", country: "CA" },
  { name: "Ottawa, ON", city: "Ottawa", country: "CA" },
  { name: "Winnipeg, MB", city: "Winnipeg", country: "CA" },
  { name: "Quebec City, QC", city: "Quebec City", country: "CA" },
  { name: "Hamilton, ON", city: "Hamilton", country: "CA" },
  { name: "Brampton, ON", city: "Brampton", country: "CA" },
  { name: "Surrey, BC", city: "Surrey", country: "CA" },
  { name: "Laval, QC", city: "Laval", country: "CA" },
  { name: "Halifax, NS", city: "Halifax", country: "CA" },
  { name: "London, ON", city: "London", country: "CA" },
  { name: "Markham, ON", city: "Markham", country: "CA" },
  { name: "Vaughan, ON", city: "Vaughan", country: "CA" },
  { name: "Gatineau, QC", city: "Gatineau", country: "CA" },
  { name: "Saskatoon, SK", city: "Saskatoon", country: "CA" },
  { name: "Longueuil, QC", city: "Longueuil", country: "CA" },
  { name: "Burnaby, BC", city: "Burnaby", country: "CA" },
  { name: "Regina, SK", city: "Regina", country: "CA" },
  { name: "Richmond, BC", city: "Richmond", country: "CA" },
  { name: "Richmond Hill, ON", city: "Richmond Hill", country: "CA" },
  { name: "Oakville, ON", city: "Oakville", country: "CA" },
  { name: "Burlington, ON", city: "Burlington", country: "CA" },
  { name: "Sherbrooke, QC", city: "Sherbrooke", country: "CA" },
  { name: "Oshawa, ON", city: "Oshawa", country: "CA" },
  { name: "Saguenay, QC", city: "Saguenay", country: "CA" },
  { name: "St. Catharines, ON", city: "St. Catharines", country: "CA" },
  { name: "Lévis, QC", city: "Lévis", country: "CA" },
  { name: "Barrie, ON", city: "Barrie", country: "CA" },
  { name: "Abbotsford, BC", city: "Abbotsford", country: "CA" },
  { name: "Coquitlam, BC", city: "Coquitlam", country: "CA" },
  { name: "St. John's, NL", city: "St. John's", country: "CA" },
  { name: "Kingston, ON", city: "Kingston", country: "CA" },
  { name: "Kelowna, BC", city: "Kelowna", country: "CA" },
  { name: "Trois-Rivières, QC", city: "Trois-Rivières", country: "CA" },

  // Mexico (Major cities)
  { name: "Mexico City, MX", city: "Mexico City", country: "MX" },
  { name: "Guadalajara, MX", city: "Guadalajara", country: "MX" },
  { name: "Monterrey, MX", city: "Monterrey", country: "MX" },
  { name: "Puebla, MX", city: "Puebla", country: "MX" },
  { name: "Toluca, MX", city: "Toluca", country: "MX" },
  { name: "Tijuana, MX", city: "Tijuana", country: "MX" },
  { name: "León, MX", city: "León", country: "MX" },
  { name: "Juárez, MX", city: "Juárez", country: "MX" },
  { name: "Torreón, MX", city: "Torreón", country: "MX" },
  { name: "Querétaro, MX", city: "Querétaro", country: "MX" },
  { name: "San Luis Potosí, MX", city: "San Luis Potosí", country: "MX" },
  { name: "Mérida, MX", city: "Mérida", country: "MX" },
  { name: "Mexicali, MX", city: "Mexicali", country: "MX" },
  { name: "Aguascalientes, MX", city: "Aguascalientes", country: "MX" },
  { name: "Acapulco, MX", city: "Acapulco", country: "MX" },
  { name: "Cuernavaca, MX", city: "Cuernavaca", country: "MX" },
  { name: "Saltillo, MX", city: "Saltillo", country: "MX" },
  { name: "Xalapa, MX", city: "Xalapa", country: "MX" },
  { name: "Reynosa, MX", city: "Reynosa", country: "MX" },
  { name: "Cancún, MX", city: "Cancún", country: "MX" },

  // South America
  { name: "São Paulo, BR", city: "Sao Paulo", country: "BR", coordinates: { lat: -23.5505, lon: -46.6333 } },
  { name: "Rio de Janeiro, BR", city: "Rio de Janeiro", country: "BR" },
  { name: "Salvador, BR", city: "Salvador", country: "BR" },
  { name: "Brasília, BR", city: "Brasilia", country: "BR" },
  { name: "Fortaleza, BR", city: "Fortaleza", country: "BR" },
  { name: "Belo Horizonte, BR", city: "Belo Horizonte", country: "BR" },
  { name: "Manaus, BR", city: "Manaus", country: "BR" },
  { name: "Curitiba, BR", city: "Curitiba", country: "BR" },
  { name: "Recife, BR", city: "Recife", country: "BR" },
  { name: "Goiânia, BR", city: "Goiania", country: "BR" },
  { name: "Belém, BR", city: "Belem", country: "BR" },
  { name: "Porto Alegre, BR", city: "Porto Alegre", country: "BR" },
  { name: "Guarulhos, BR", city: "Guarulhos", country: "BR" },
  { name: "Campinas, BR", city: "Campinas", country: "BR" },
  { name: "São Luís, BR", city: "Sao Luis", country: "BR" },
  { name: "São Gonçalo, BR", city: "Sao Goncalo", country: "BR" },
  { name: "Maceió, BR", city: "Maceio", country: "BR" },
  { name: "Duque de Caxias, BR", city: "Duque de Caxias", country: "BR" },
  { name: "Teresina, BR", city: "Teresina", country: "BR" },
  { name: "Natal, BR", city: "Natal", country: "BR" },
  { name: "Campo Grande, BR", city: "Campo Grande", country: "BR" },
  { name: "Nova Iguaçu, BR", city: "Nova Iguacu", country: "BR" },
  {
    name: "São Bernardo do Campo, BR",
    city: "Sao Bernardo do Campo",
    country: "BR",
  },
  { name: "João Pessoa, BR", city: "Joao Pessoa", country: "BR" },
  { name: "Santo André, BR", city: "Santo Andre", country: "BR" },
  { name: "Osasco, BR", city: "Osasco", country: "BR" },

  { name: "Buenos Aires, AR", city: "Buenos Aires", country: "AR" },
  { name: "Córdoba, AR", city: "Cordoba", country: "AR" },
  { name: "Rosario, AR", city: "Rosario", country: "AR" },
  { name: "Mendoza, AR", city: "Mendoza", country: "AR" },
  {
    name: "San Miguel de Tucumán, AR",
    city: "San Miguel de Tucuman",
    country: "AR",
  },
  { name: "La Plata, AR", city: "La Plata", country: "AR" },
  { name: "Mar del Plata, AR", city: "Mar del Plata", country: "AR" },
  { name: "Salta, AR", city: "Salta", country: "AR" },
  { name: "Santa Fe, AR", city: "Santa Fe", country: "AR" },
  { name: "San Juan, AR", city: "San Juan", country: "AR" },

  { name: "Lima, PE", city: "Lima", country: "PE" },
  { name: "Arequipa, PE", city: "Arequipa", country: "PE" },
  { name: "Trujillo, PE", city: "Trujillo", country: "PE" },
  { name: "Chiclayo, PE", city: "Chiclayo", country: "PE" },
  { name: "Piura, PE", city: "Piura", country: "PE" },
  { name: "Iquitos, PE", city: "Iquitos", country: "PE" },
  { name: "Cusco, PE", city: "Cusco", country: "PE" },
  { name: "Chimbote, PE", city: "Chimbote", country: "PE" },
  { name: "Huancayo, PE", city: "Huancayo", country: "PE" },

  { name: "Santiago, CL", city: "Santiago", country: "CL" },
  { name: "Valparaíso, CL", city: "Valparaiso", country: "CL" },
  { name: "Concepción, CL", city: "Concepcion", country: "CL" },
  { name: "La Serena, CL", city: "La Serena", country: "CL" },
  { name: "Antofagasta, CL", city: "Antofagasta", country: "CL" },
  { name: "Temuco, CL", city: "Temuco", country: "CL" },
  { name: "Rancagua, CL", city: "Rancagua", country: "CL" },
  { name: "Talca, CL", city: "Talca", country: "CL" },
  { name: "Iquique, CL", city: "Iquique", country: "CL" },

  { name: "Bogotá, CO", city: "Bogota", country: "CO" },
  { name: "Medellín, CO", city: "Medellin", country: "CO" },
  { name: "Cali, CO", city: "Cali", country: "CO" },
  { name: "Barranquilla, CO", city: "Barranquilla", country: "CO" },
  { name: "Cartagena, CO", city: "Cartagena", country: "CO" },
  { name: "Cúcuta, CO", city: "Cucuta", country: "CO" },
  { name: "Soledad, CO", city: "Soledad", country: "CO" },
  { name: "Ibagué, CO", city: "Ibague", country: "CO" },
  { name: "Bucaramanga, CO", city: "Bucaramanga", country: "CO" },
  { name: "Santa Marta, CO", city: "Santa Marta", country: "CO" },

  { name: "Montevideo, UY", city: "Montevideo", country: "UY" },
  { name: "Salto, UY", city: "Salto", country: "UY" },
  { name: "Ciudad de la Costa, UY", city: "Ciudad de la Costa", country: "UY" },
  { name: "Paysandú, UY", city: "Paysandu", country: "UY" },

  // Europe
  // United Kingdom
  { name: "London, UK", city: "London", country: "GB" },
  { name: "Birmingham, UK", city: "Birmingham", country: "GB" },
  { name: "Liverpool, UK", city: "Liverpool", country: "GB" },
  { name: "Sheffield, UK", city: "Sheffield", country: "GB" },
  { name: "Bristol, UK", city: "Bristol", country: "GB" },
  { name: "Glasgow, UK", city: "Glasgow", country: "GB" },
  { name: "Leicester, UK", city: "Leicester", country: "GB" },
  { name: "Edinburgh, UK", city: "Edinburgh", country: "GB" },
  { name: "Leeds, UK", city: "Leeds", country: "GB" },
  { name: "Cardiff, UK", city: "Cardiff", country: "GB" },
  { name: "Manchester, UK", city: "Manchester", country: "GB", coordinates: { lat: 53.4808, lon: -2.2426 } },
  { name: "Stoke-on-Trent, UK", city: "Stoke-on-Trent", country: "GB" },
  { name: "Coventry, UK", city: "Coventry", country: "GB" },
  { name: "Sunderland, UK", city: "Sunderland", country: "GB" },
  { name: "Birkenhead, UK", city: "Birkenhead", country: "GB" },
  { name: "Islington, UK", city: "Islington", country: "GB" },
  { name: "Reading, UK", city: "Reading", country: "GB" },
  { name: "Preston, UK", city: "Preston", country: "GB" },
  { name: "Newport, UK", city: "Newport", country: "GB" },
  { name: "Swansea, UK", city: "Swansea", country: "GB" },
  { name: "Bradford, UK", city: "Bradford", country: "GB" },
  { name: "Southend-on-Sea, UK", city: "Southend-on-Sea", country: "GB" },
  { name: "Belfast, UK", city: "Belfast", country: "GB" },
  { name: "Derby, UK", city: "Derby", country: "GB" },
  { name: "Plymouth, UK", city: "Plymouth", country: "GB" },
  { name: "Luton, UK", city: "Luton", country: "GB" },
  { name: "Wolverhampton, UK", city: "Wolverhampton", country: "GB" },
  { name: "Portsmouth, UK", city: "Portsmouth", country: "GB" },
  { name: "Southampton, UK", city: "Southampton", country: "GB" },
  { name: "Blackpool, UK", city: "Blackpool", country: "GB" },
  {
    name: "Newcastle upon Tyne, UK",
    city: "Newcastle upon Tyne",
    country: "GB",
  },
  { name: "Nottingham, UK", city: "Nottingham", country: "GB" },
  { name: "Hull, UK", city: "Hull", country: "GB" },
  { name: "York, UK", city: "York", country: "GB" },
  { name: "Aberdeen, UK", city: "Aberdeen", country: "GB" },
  { name: "Brighton, UK", city: "Brighton", country: "GB" },

  // France
  { name: "Paris, FR", city: "Paris", country: "FR" },
  { name: "Marseille, FR", city: "Marseille", country: "FR" },
  { name: "Lyon, FR", city: "Lyon", country: "FR" },
  { name: "Toulouse, FR", city: "Toulouse", country: "FR" },
  { name: "Nice, FR", city: "Nice", country: "FR" },
  { name: "Nantes, FR", city: "Nantes", country: "FR" },
  { name: "Strasbourg, FR", city: "Strasbourg", country: "FR" },
  { name: "Montpellier, FR", city: "Montpellier", country: "FR" },
  { name: "Bordeaux, FR", city: "Bordeaux", country: "FR" },
  { name: "Lille, FR", city: "Lille", country: "FR" },
  { name: "Rennes, FR", city: "Rennes", country: "FR" },
  { name: "Reims, FR", city: "Reims", country: "FR" },
  { name: "Le Havre, FR", city: "Le Havre", country: "FR" },
  { name: "Saint-Étienne, FR", city: "Saint-Etienne", country: "FR" },
  { name: "Toulon, FR", city: "Toulon", country: "FR" },
  { name: "Angers, FR", city: "Angers", country: "FR" },
  { name: "Grenoble, FR", city: "Grenoble", country: "FR" },
  { name: "Dijon, FR", city: "Dijon", country: "FR" },
  { name: "Nîmes, FR", city: "Nimes", country: "FR" },
  { name: "Aix-en-Provence, FR", city: "Aix-en-Provence", country: "FR" },
  {
    name: "Saint-Quentin-en-Yvelines, FR",
    city: "Saint-Quentin-en-Yvelines",
    country: "FR",
  },
  { name: "Brest, FR", city: "Brest", country: "FR" },
  { name: "Le Mans, FR", city: "Le Mans", country: "FR" },
  { name: "Amiens, FR", city: "Amiens", country: "FR" },
  { name: "Tours, FR", city: "Tours", country: "FR" },
  { name: "Limoges, FR", city: "Limoges", country: "FR" },
  { name: "Clermont-Ferrand, FR", city: "Clermont-Ferrand", country: "FR" },
  { name: "Villeurbanne, FR", city: "Villeurbanne", country: "FR" },
  { name: "Besançon, FR", city: "Besancon", country: "FR" },
  { name: "Orléans, FR", city: "Orleans", country: "FR" },
  { name: "Mulhouse, FR", city: "Mulhouse", country: "FR" },
  { name: "Caen, FR", city: "Caen", country: "FR" },
  { name: "Nancy, FR", city: "Nancy", country: "FR" },

  // Germany
  { name: "Berlin, DE", city: "Berlin", country: "DE", coordinates: { lat: 52.52, lon: 13.405 } },
  { name: "Hamburg, DE", city: "Hamburg", country: "DE" },
  { name: "Munich, DE", city: "Munich", country: "DE" },
  { name: "Cologne, DE", city: "Cologne", country: "DE" },
  { name: "Frankfurt am Main, DE", city: "Frankfurt", country: "DE" },
  { name: "Stuttgart, DE", city: "Stuttgart", country: "DE" },
  { name: "Düsseldorf, DE", city: "Dusseldorf", country: "DE" },
  { name: "Dortmund, DE", city: "Dortmund", country: "DE" },
  { name: "Essen, DE", city: "Essen", country: "DE" },
  { name: "Leipzig, DE", city: "Leipzig", country: "DE" },
  { name: "Bremen, DE", city: "Bremen", country: "DE" },
  { name: "Dresden, DE", city: "Dresden", country: "DE" },
  { name: "Hanover, DE", city: "Hanover", country: "DE" },
  { name: "Nuremberg, DE", city: "Nuremberg", country: "DE" },
  { name: "Duisburg, DE", city: "Duisburg", country: "DE" },
  { name: "Bochum, DE", city: "Bochum", country: "DE" },
  { name: "Wuppertal, DE", city: "Wuppertal", country: "DE" },
  { name: "Bielefeld, DE", city: "Bielefeld", country: "DE" },
  { name: "Bonn, DE", city: "Bonn", country: "DE" },
  { name: "Münster, DE", city: "Munster", country: "DE" },
  { name: "Karlsruhe, DE", city: "Karlsruhe", country: "DE" },
  { name: "Mannheim, DE", city: "Mannheim", country: "DE" },
  { name: "Augsburg, DE", city: "Augsburg", country: "DE" },
  { name: "Wiesbaden, DE", city: "Wiesbaden", country: "DE" },
  { name: "Gelsenkirchen, DE", city: "Gelsenkirchen", country: "DE" },
  { name: "Mönchengladbach, DE", city: "Monchengladbach", country: "DE" },
  { name: "Braunschweig, DE", city: "Braunschweig", country: "DE" },
  { name: "Chemnitz, DE", city: "Chemnitz", country: "DE" },
  { name: "Kiel, DE", city: "Kiel", country: "DE" },
  { name: "Aachen, DE", city: "Aachen", country: "DE" },
  { name: "Halle, DE", city: "Halle", country: "DE" },
  { name: "Magdeburg, DE", city: "Magdeburg", country: "DE" },
  { name: "Freiburg im Breisgau, DE", city: "Freiburg", country: "DE" },
  { name: "Krefeld, DE", city: "Krefeld", country: "DE" },
  { name: "Lübeck, DE", city: "Lubeck", country: "DE" },
  { name: "Oberhausen, DE", city: "Oberhausen", country: "DE" },

  // Spain
  { name: "Madrid, ES", city: "Madrid", country: "ES" },
  { name: "Barcelona, ES", city: "Barcelona", country: "ES" },
  { name: "Valencia, ES", city: "Valencia", country: "ES" },
  { name: "Seville, ES", city: "Seville", country: "ES" },
  { name: "Zaragoza, ES", city: "Zaragoza", country: "ES" },
  { name: "Málaga, ES", city: "Malaga", country: "ES" },
  { name: "Murcia, ES", city: "Murcia", country: "ES" },
  { name: "Palma, ES", city: "Palma", country: "ES" },
  { name: "Las Palmas de Gran Canaria, ES", city: "Las Palmas", country: "ES" },
  { name: "Bilbao, ES", city: "Bilbao", country: "ES" },
  { name: "Alicante, ES", city: "Alicante", country: "ES" },
  { name: "Córdoba, ES", city: "Cordoba", country: "ES" },
  { name: "Valladolid, ES", city: "Valladolid", country: "ES" },
  { name: "Vigo, ES", city: "Vigo", country: "ES" },
  { name: "Gijón, ES", city: "Gijon", country: "ES" },
  {
    name: "Hospitalet de Llobregat, ES",
    city: "Hospitalet de Llobregat",
    country: "ES",
  },
  { name: "Vitoria-Gasteiz, ES", city: "Vitoria-Gasteiz", country: "ES" },
  { name: "A Coruña, ES", city: "A Coruna", country: "ES" },
  { name: "Granada, ES", city: "Granada", country: "ES" },
  { name: "Elche, ES", city: "Elche", country: "ES" },
  { name: "Oviedo, ES", city: "Oviedo", country: "ES" },
  {
    name: "Santa Cruz de Tenerife, ES",
    city: "Santa Cruz de Tenerife",
    country: "ES",
  },
  { name: "Badalona, ES", city: "Badalona", country: "ES" },
  { name: "Cartagena, ES", city: "Cartagena", country: "ES" },
  {
    name: "Jerez de la Frontera, ES",
    city: "Jerez de la Frontera",
    country: "ES",
  },
  { name: "Sabadell, ES", city: "Sabadell", country: "ES" },
  { name: "Móstoles, ES", city: "Mostoles", country: "ES" },
  { name: "Alcalá de Henares, ES", city: "Alcala de Henares", country: "ES" },
  { name: "Pamplona, ES", city: "Pamplona", country: "ES" },
  { name: "Fuenlabrada, ES", city: "Fuenlabrada", country: "ES" },
  { name: "Almería, ES", city: "Almeria", country: "ES" },
  { name: "Leganés, ES", city: "Leganes", country: "ES" },

  // Italy
  { name: "Rome, IT", city: "Rome", country: "IT", coordinates: { lat: 41.9028, lon: 12.4964 } },
  { name: "Milan, IT", city: "Milan", country: "IT" },
  { name: "Naples, IT", city: "Naples", country: "IT" },
  { name: "Turin, IT", city: "Turin", country: "IT" },
  { name: "Palermo, IT", city: "Palermo", country: "IT" },
  { name: "Genoa, IT", city: "Genoa", country: "IT" },
  { name: "Bologna, IT", city: "Bologna", country: "IT" },
  { name: "Florence, IT", city: "Florence", country: "IT" },
  { name: "Bari, IT", city: "Bari", country: "IT" },
  { name: "Catania, IT", city: "Catania", country: "IT" },
  { name: "Venice, IT", city: "Venice", country: "IT" },
  { name: "Verona, IT", city: "Verona", country: "IT" },
  { name: "Messina, IT", city: "Messina", country: "IT" },
  { name: "Padua, IT", city: "Padua", country: "IT" },
  { name: "Trieste, IT", city: "Trieste", country: "IT" },
  { name: "Brescia, IT", city: "Brescia", country: "IT" },
  { name: "Taranto, IT", city: "Taranto", country: "IT" },
  { name: "Prato, IT", city: "Prato", country: "IT" },
  { name: "Parma, IT", city: "Parma", country: "IT" },
  { name: "Modena, IT", city: "Modena", country: "IT" },
  { name: "Reggio Calabria, IT", city: "Reggio Calabria", country: "IT" },
  { name: "Reggio Emilia, IT", city: "Reggio Emilia", country: "IT" },
  { name: "Perugia, IT", city: "Perugia", country: "IT" },
  { name: "Livorno, IT", city: "Livorno", country: "IT" },
  { name: "Ravenna, IT", city: "Ravenna", country: "IT" },
  { name: "Cagliari, IT", city: "Cagliari", country: "IT" },
  { name: "Foggia, IT", city: "Foggia", country: "IT" },
  { name: "Rimini, IT", city: "Rimini", country: "IT" },
  { name: "Salerno, IT", city: "Salerno", country: "IT" },
  { name: "Ferrara, IT", city: "Ferrara", country: "IT" },
  { name: "Sassari, IT", city: "Sassari", country: "IT" },

  // Netherlands
  { name: "Amsterdam, NL", city: "Amsterdam", country: "NL", coordinates: { lat: 52.3676, lon: 4.9041 } },
  { name: "Rotterdam, NL", city: "Rotterdam", country: "NL" },
  { name: "The Hague, NL", city: "The Hague", country: "NL" },
  { name: "Utrecht, NL", city: "Utrecht", country: "NL" },
  { name: "Eindhoven, NL", city: "Eindhoven", country: "NL" },
  { name: "Tilburg, NL", city: "Tilburg", country: "NL" },
  { name: "Groningen, NL", city: "Groningen", country: "NL" },
  { name: "Almere, NL", city: "Almere", country: "NL" },
  { name: "Breda, NL", city: "Breda", country: "NL" },
  { name: "Nijmegen, NL", city: "Nijmegen", country: "NL" },
  { name: "Enschede, NL", city: "Enschede", country: "NL" },
  { name: "Haarlem, NL", city: "Haarlem", country: "NL" },
  { name: "Arnhem, NL", city: "Arnhem", country: "NL" },
  { name: "Zaanstad, NL", city: "Zaanstad", country: "NL" },
  { name: "Amersfoort, NL", city: "Amersfoort", country: "NL" },
  { name: "Apeldoorn, NL", city: "Apeldoorn", country: "NL" },

  // Other European countries
  { name: "Brussels, BE", city: "Brussels", country: "BE" },
  { name: "Antwerp, BE", city: "Antwerp", country: "BE" },
  { name: "Ghent, BE", city: "Ghent", country: "BE" },
  { name: "Charleroi, BE", city: "Charleroi", country: "BE" },
  { name: "Liège, BE", city: "Liege", country: "BE" },
  { name: "Bruges, BE", city: "Bruges", country: "BE" },

  { name: "Vienna, AT", city: "Vienna", country: "AT" },
  { name: "Graz, AT", city: "Graz", country: "AT" },
  { name: "Linz, AT", city: "Linz", country: "AT" },
  { name: "Salzburg, AT", city: "Salzburg", country: "AT" },
  { name: "Innsbruck, AT", city: "Innsbruck", country: "AT" },
  { name: "Klagenfurt, AT", city: "Klagenfurt", country: "AT" },

  { name: "Zurich, CH", city: "Zurich", country: "CH" },
  { name: "Geneva, CH", city: "Geneva", country: "CH" },
  { name: "Basel, CH", city: "Basel", country: "CH" },
  { name: "Lausanne, CH", city: "Lausanne", country: "CH" },
  { name: "Bern, CH", city: "Bern", country: "CH" },
  { name: "Winterthur, CH", city: "Winterthur", country: "CH" },

  { name: "Prague, CZ", city: "Prague", country: "CZ" },
  { name: "Brno, CZ", city: "Brno", country: "CZ" },
  { name: "Ostrava, CZ", city: "Ostrava", country: "CZ" },
  { name: "Plzen, CZ", city: "Plzen", country: "CZ" },
  { name: "Liberec, CZ", city: "Liberec", country: "CZ" },
  { name: "Olomouc, CZ", city: "Olomouc", country: "CZ" },

  { name: "Warsaw, PL", city: "Warsaw", country: "PL" },
  { name: "Kraków, PL", city: "Krakow", country: "PL" },
  { name: "Łódź, PL", city: "Lodz", country: "PL" },
  { name: "Wrocław, PL", city: "Wroclaw", country: "PL" },
  { name: "Poznań, PL", city: "Poznan", country: "PL" },
  { name: "Gdańsk, PL", city: "Gdansk", country: "PL" },
  { name: "Szczecin, PL", city: "Szczecin", country: "PL" },
  { name: "Bydgoszcz, PL", city: "Bydgoszcz", country: "PL" },
  { name: "Lublin, PL", city: "Lublin", country: "PL" },
  { name: "Białystok, PL", city: "Bialystok", country: "PL" },
  { name: "Katowice, PL", city: "Katowice", country: "PL" },

  // Russia
  { name: "Moscow, RU", city: "Moscow", country: "RU", coordinates: { lat: 55.7558, lon: 37.6173 } },

  { name: "Budapest, HU", city: "Budapest", country: "HU", coordinates: { lat: 47.4979, lon: 19.0402 } },
  { name: "Debrecen, HU", city: "Debrecen", country: "HU" },
  { name: "Szeged, HU", city: "Szeged", country: "HU" },
  { name: "Miskolc, HU", city: "Miskolc", country: "HU" },
  { name: "Pécs, HU", city: "Pecs", country: "HU" },
  { name: "Győr, HU", city: "Gyor", country: "HU" },

  { name: "Bucharest, RO", city: "Bucharest", country: "RO" },
  { name: "Cluj-Napoca, RO", city: "Cluj-Napoca", country: "RO" },
  { name: "Timișoara, RO", city: "Timisoara", country: "RO" },
  { name: "Iași, RO", city: "Iasi", country: "RO" },
  { name: "Constanța, RO", city: "Constanta", country: "RO" },
  { name: "Craiova, RO", city: "Craiova", country: "RO" },
  { name: "Brașov, RO", city: "Brasov", country: "RO" },
  { name: "Galați, RO", city: "Galati", country: "RO" },

  { name: "Athens, GR", city: "Athens", country: "GR" },
  { name: "Thessaloniki, GR", city: "Thessaloniki", country: "GR" },
  { name: "Patras, GR", city: "Patras", country: "GR" },
  {
    name: "Rio, Greece",
    city: "Rio",
    country: "GR",
    coordinates: { lat: 38.293, lon: 21.7857 },
  },
  { name: "Piraeus, GR", city: "Piraeus", country: "GR" },
  { name: "Larissa, GR", city: "Larissa", country: "GR" },
  { name: "Heraklion, GR", city: "Heraklion", country: "GR" },

  { name: "Sofia, BG", city: "Sofia", country: "BG" },
  { name: "Plovdiv, BG", city: "Plovdiv", country: "BG" },
  { name: "Varna, BG", city: "Varna", country: "BG" },
  { name: "Burgas, BG", city: "Burgas", country: "BG" },
  { name: "Ruse, BG", city: "Ruse", country: "BG" },
  { name: "Stara Zagora, BG", city: "Stara Zagora", country: "BG" },

  { name: "Belgrade, RS", city: "Belgrade", country: "RS" },
  { name: "Novi Sad, RS", city: "Novi Sad", country: "RS" },
  { name: "Niš, RS", city: "Nis", country: "RS" },
  { name: "Kragujevac, RS", city: "Kragujevac", country: "RS" },

  { name: "Copenhagen, DK", city: "Copenhagen", country: "DK" },
  { name: "Aarhus, DK", city: "Aarhus", country: "DK" },
  { name: "Odense, DK", city: "Odense", country: "DK" },
  { name: "Aalborg, DK", city: "Aalborg", country: "DK" },
  { name: "Esbjerg, DK", city: "Esbjerg", country: "DK" },
  { name: "Randers, DK", city: "Randers", country: "DK" },

  { name: "Oslo, NO", city: "Oslo", country: "NO" },
  { name: "Bergen, NO", city: "Bergen", country: "NO" },
  { name: "Stavanger, NO", city: "Stavanger", country: "NO" },
  { name: "Trondheim, NO", city: "Trondheim", country: "NO" },
  { name: "Drammen, NO", city: "Drammen", country: "NO" },
  { name: "Fredrikstad, NO", city: "Fredrikstad", country: "NO" },

  { name: "Stockholm, SE", city: "Stockholm", country: "SE" },
  { name: "Gothenburg, SE", city: "Gothenburg", country: "SE" },
  { name: "Malmö, SE", city: "Malmo", country: "SE" },
  { name: "Uppsala, SE", city: "Uppsala", country: "SE" },
  { name: "Västerås, SE", city: "Vasteras", country: "SE" },
  { name: "Örebro, SE", city: "Orebro", country: "SE" },
  { name: "Linköping, SE", city: "Linkoping", country: "SE" },
  { name: "Helsingborg, SE", city: "Helsingborg", country: "SE" },

  { name: "Helsinki, FI", city: "Helsinki", country: "FI" },
  { name: "Espoo, FI", city: "Espoo", country: "FI" },
  { name: "Tampere, FI", city: "Tampere", country: "FI" },
  { name: "Vantaa, FI", city: "Vantaa", country: "FI" },
  { name: "Oulu, FI", city: "Oulu", country: "FI" },
  { name: "Turku, FI", city: "Turku", country: "FI" },
  { name: "Jyväskylä, FI", city: "Jyvaskyla", country: "FI" },
  { name: "Lahti, FI", city: "Lahti", country: "FI" },

  { name: "Dublin, IE", city: "Dublin", country: "IE" },
  { name: "Cork, IE", city: "Cork", country: "IE" },
  { name: "Limerick, IE", city: "Limerick", country: "IE" },
  { name: "Galway, IE", city: "Galway", country: "IE" },
  { name: "Waterford, IE", city: "Waterford", country: "IE" },
  { name: "Drogheda, IE", city: "Drogheda", country: "IE" },

  { name: "Lisbon, PT", city: "Lisbon", country: "PT" },
  { name: "Porto, PT", city: "Porto", country: "PT" },
  { name: "Vila Nova de Gaia, PT", city: "Vila Nova de Gaia", country: "PT" },
  { name: "Amadora, PT", city: "Amadora", country: "PT" },
  { name: "Braga, PT", city: "Braga", country: "PT" },
  { name: "Coimbra, PT", city: "Coimbra", country: "PT" },
  { name: "Funchal, PT", city: "Funchal", country: "PT" },
  { name: "Almada, PT", city: "Almada", country: "PT" },

  // Asia
  // Japan
  { name: "Tokyo, JP", city: "Tokyo", country: "JP" },
  { name: "Yokohama, JP", city: "Yokohama", country: "JP" },
  { name: "Osaka, JP", city: "Osaka", country: "JP", coordinates: { lat: 34.6937, lon: 135.5023 } },
  { name: "Nagoya, JP", city: "Nagoya", country: "JP" },
  { name: "Sapporo, JP", city: "Sapporo", country: "JP" },
  { name: "Fukuoka, JP", city: "Fukuoka", country: "JP" },
  { name: "Kobe, JP", city: "Kobe", country: "JP" },
  { name: "Kawasaki, JP", city: "Kawasaki", country: "JP" },
  { name: "Kyoto, JP", city: "Kyoto", country: "JP" },
  { name: "Saitama, JP", city: "Saitama", country: "JP" },
  { name: "Hiroshima, JP", city: "Hiroshima", country: "JP" },
  { name: "Sendai, JP", city: "Sendai", country: "JP" },
  { name: "Kitakyushu, JP", city: "Kitakyushu", country: "JP" },
  { name: "Chiba, JP", city: "Chiba", country: "JP" },
  { name: "Sakai, JP", city: "Sakai", country: "JP" },
  { name: "Niigata, JP", city: "Niigata", country: "JP" },
  { name: "Hamamatsu, JP", city: "Hamamatsu", country: "JP" },
  { name: "Kumamoto, JP", city: "Kumamoto", country: "JP" },
  { name: "Sagamihara, JP", city: "Sagamihara", country: "JP" },
  { name: "Okayama, JP", city: "Okayama", country: "JP" },
  { name: "Kagoshima, JP", city: "Kagoshima", country: "JP" },
  { name: "Hachioji, JP", city: "Hachioji", country: "JP" },
  { name: "Funabashi, JP", city: "Funabashi", country: "JP" },
  { name: "Nara, JP", city: "Nara", country: "JP" },
  { name: "Kawaguchi, JP", city: "Kawaguchi", country: "JP" },
  { name: "Himeji, JP", city: "Himeji", country: "JP" },
  { name: "Matsuyama, JP", city: "Matsuyama", country: "JP" },
  { name: "Toyonaka, JP", city: "Toyonaka", country: "JP" },
  { name: "Kanazawa, JP", city: "Kanazawa", country: "JP" },
  { name: "Utsunomiya, JP", city: "Utsunomiya", country: "JP" },

  // South Korea
  { name: "Seoul, KR", city: "Seoul", country: "KR" },
  { name: "Busan, KR", city: "Busan", country: "KR" },
  { name: "Incheon, KR", city: "Incheon", country: "KR" },
  { name: "Daegu, KR", city: "Daegu", country: "KR" },
  { name: "Daejeon, KR", city: "Daejeon", country: "KR" },
  { name: "Gwangju, KR", city: "Gwangju", country: "KR" },
  { name: "Suwon, KR", city: "Suwon", country: "KR" },
  { name: "Ulsan, KR", city: "Ulsan", country: "KR" },
  { name: "Changwon, KR", city: "Changwon", country: "KR" },
  { name: "Goyang, KR", city: "Goyang", country: "KR" },
  { name: "Yongin, KR", city: "Yongin", country: "KR" },
  { name: "Bucheon, KR", city: "Bucheon", country: "KR" },
  { name: "Ansan, KR", city: "Ansan", country: "KR" },
  { name: "Cheongju, KR", city: "Cheongju", country: "KR" },
  { name: "Jeonju, KR", city: "Jeonju", country: "KR" },
  { name: "Anyang, KR", city: "Anyang", country: "KR" },
  { name: "Cheonan, KR", city: "Cheonan", country: "KR" },
  { name: "Namyangju, KR", city: "Namyangju", country: "KR" },
  { name: "Pohang, KR", city: "Pohang", country: "KR" },
  { name: "Uijeongbu, KR", city: "Uijeongbu", country: "KR" },

  // China
  { name: "Shanghai, CN", city: "Shanghai", country: "CN" },
  { name: "Beijing, CN", city: "Beijing", country: "CN" },
  { name: "Chongqing, CN", city: "Chongqing", country: "CN" },
  { name: "Tianjin, CN", city: "Tianjin", country: "CN" },
  { name: "Guangzhou, CN", city: "Guangzhou", country: "CN" },
  { name: "Shenzhen, CN", city: "Shenzhen", country: "CN" },
  { name: "Wuhan, CN", city: "Wuhan", country: "CN" },
  { name: "Dongguan, CN", city: "Dongguan", country: "CN" },
  { name: "Chengdu, CN", city: "Chengdu", country: "CN" },
  { name: "Nanjing, CN", city: "Nanjing", country: "CN" },
  { name: "Foshan, CN", city: "Foshan", country: "CN" },
  { name: "Shenyang, CN", city: "Shenyang", country: "CN" },
  { name: "Qingdao, CN", city: "Qingdao", country: "CN" },
  { name: "Xi'an, CN", city: "Xi'an", country: "CN" },
  { name: "Suzhou, CN", city: "Suzhou", country: "CN" },
  { name: "Zhengzhou, CN", city: "Zhengzhou", country: "CN" },
  { name: "Jinan, CN", city: "Jinan", country: "CN" },
  { name: "Harbin, CN", city: "Harbin", country: "CN" },
  { name: "Kunming, CN", city: "Kunming", country: "CN" },
  { name: "Hangzhou, CN", city: "Hangzhou", country: "CN" },
  { name: "Dalian, CN", city: "Dalian", country: "CN" },
  { name: "Changchun, CN", city: "Changchun", country: "CN" },
  { name: "Taiyuan, CN", city: "Taiyuan", country: "CN" },
  { name: "Shijiazhuang, CN", city: "Shijiazhuang", country: "CN" },
  { name: "Ürümqi, CN", city: "Urumqi", country: "CN" },
  { name: "Hefei, CN", city: "Hefei", country: "CN" },
  { name: "Fuzhou, CN", city: "Fuzhou", country: "CN" },
  { name: "Wuxi, CN", city: "Wuxi", country: "CN" },
  { name: "Zhongshan, CN", city: "Zhongshan", country: "CN" },
  { name: "Wenzhou, CN", city: "Wenzhou", country: "CN" },

  // Hong Kong & Taiwan
  { name: "Hong Kong, HK", city: "Hong Kong", country: "HK" },
  { name: "Taipei, TW", city: "Taipei", country: "TW" },
  { name: "Kaohsiung, TW", city: "Kaohsiung", country: "TW" },
  { name: "Taichung, TW", city: "Taichung", country: "TW" },
  { name: "Tainan, TW", city: "Tainan", country: "TW" },
  { name: "Taoyuan, TW", city: "Taoyuan", country: "TW" },
  { name: "Hsinchu, TW", city: "Hsinchu", country: "TW" },

  // Southeast Asia
  { name: "Singapore, SG", city: "Singapore", country: "SG" },

  { name: "Kuala Lumpur, MY", city: "Kuala Lumpur", country: "MY" },
  { name: "George Town, MY", city: "George Town", country: "MY" },
  { name: "Ipoh, MY", city: "Ipoh", country: "MY" },
  { name: "Shah Alam, MY", city: "Shah Alam", country: "MY" },
  { name: "Petaling Jaya, MY", city: "Petaling Jaya", country: "MY" },
  { name: "Johor Bahru, MY", city: "Johor Bahru", country: "MY" },
  { name: "Subang Jaya, MY", city: "Subang Jaya", country: "MY" },
  { name: "Kota Kinabalu, MY", city: "Kota Kinabalu", country: "MY" },
  { name: "Seremban, MY", city: "Seremban", country: "MY" },
  { name: "Kuching, MY", city: "Kuching", country: "MY" },

  { name: "Bangkok, TH", city: "Bangkok", country: "TH" },
  { name: "Samut Prakan, TH", city: "Samut Prakan", country: "TH" },
  { name: "Mueang Nonthaburi, TH", city: "Mueang Nonthaburi", country: "TH" },
  { name: "Udon Thani, TH", city: "Udon Thani", country: "TH" },
  { name: "Chon Buri, TH", city: "Chon Buri", country: "TH" },
  { name: "Nakhon Ratchasima, TH", city: "Nakhon Ratchasima", country: "TH" },
  { name: "Chiang Mai, TH", city: "Chiang Mai", country: "TH" },
  { name: "Hat Yai, TH", city: "Hat Yai", country: "TH" },
  { name: "Pak Kret, TH", city: "Pak Kret", country: "TH" },
  { name: "Si Racha, TH", city: "Si Racha", country: "TH" },
  { name: "Phuket, TH", city: "Phuket", country: "TH" },

  { name: "Ho Chi Minh City, VN", city: "Ho Chi Minh City", country: "VN" },
  { name: "Hanoi, VN", city: "Hanoi", country: "VN" },
  { name: "Hai Phong, VN", city: "Hai Phong", country: "VN" },
  { name: "Can Tho, VN", city: "Can Tho", country: "VN" },
  { name: "Da Nang, VN", city: "Da Nang", country: "VN" },
  { name: "Hue, VN", city: "Hue", country: "VN" },
  { name: "Nha Trang, VN", city: "Nha Trang", country: "VN" },
  { name: "Buon Ma Thuot, VN", city: "Buon Ma Thuot", country: "VN" },
  { name: "Quy Nhon, VN", city: "Quy Nhon", country: "VN" },
  { name: "Vung Tau, VN", city: "Vung Tau", country: "VN" },

  { name: "Jakarta, ID", city: "Jakarta", country: "ID" },
  { name: "Surabaya, ID", city: "Surabaya", country: "ID" },
  { name: "Medan, ID", city: "Medan", country: "ID" },
  { name: "Bandung, ID", city: "Bandung", country: "ID" },
  { name: "Bekasi, ID", city: "Bekasi", country: "ID" },
  { name: "Palembang, ID", city: "Palembang", country: "ID" },
  { name: "Tangerang, ID", city: "Tangerang", country: "ID" },
  { name: "Makassar, ID", city: "Makassar", country: "ID" },
  { name: "South Tangerang, ID", city: "South Tangerang", country: "ID" },
  { name: "Batam, ID", city: "Batam", country: "ID" },
  { name: "Bogor, ID", city: "Bogor", country: "ID" },
  { name: "Pekanbaru, ID", city: "Pekanbaru", country: "ID" },
  { name: "Bandar Lampung, ID", city: "Bandar Lampung", country: "ID" },
  { name: "Malang, ID", city: "Malang", country: "ID" },
  { name: "Padang, ID", city: "Padang", country: "ID" },
  { name: "Semarang, ID", city: "Semarang", country: "ID" },
  { name: "Denpasar, ID", city: "Denpasar", country: "ID" },

  { name: "Manila, PH", city: "Manila", country: "PH" },
  { name: "Quezon City, PH", city: "Quezon City", country: "PH" },
  { name: "Caloocan, PH", city: "Caloocan", country: "PH" },
  { name: "Davao City, PH", city: "Davao City", country: "PH" },
  { name: "Cebu City, PH", city: "Cebu City", country: "PH" },
  { name: "Zamboanga City, PH", city: "Zamboanga City", country: "PH" },
  { name: "Taguig, PH", city: "Taguig", country: "PH" },
  { name: "Antipolo, PH", city: "Antipolo", country: "PH" },
  { name: "Pasig, PH", city: "Pasig", country: "PH" },
  { name: "Cagayan de Oro, PH", city: "Cagayan de Oro", country: "PH" },
  { name: "Paranaque, PH", city: "Paranaque", country: "PH" },
  { name: "Dasmarinas, PH", city: "Dasmarinas", country: "PH" },
  { name: "Valenzuela, PH", city: "Valenzuela", country: "PH" },
  { name: "Bacoor, PH", city: "Bacoor", country: "PH" },
  { name: "General Santos, PH", city: "General Santos", country: "PH" },
  { name: "Las Pinas, PH", city: "Las Pinas", country: "PH" },

  // South Asia
  { name: "Mumbai, IN", city: "Mumbai", country: "IN" },
  { name: "Delhi, IN", city: "Delhi", country: "IN" },
  { name: "Bangalore, IN", city: "Bengaluru", country: "IN" },
  { name: "Hyderabad, IN", city: "Hyderabad", country: "IN" },
  { name: "Ahmedabad, IN", city: "Ahmedabad", country: "IN" },
  { name: "Chennai, IN", city: "Chennai", country: "IN" },
  { name: "Kolkata, IN", city: "Kolkata", country: "IN" },
  { name: "Surat, IN", city: "Surat", country: "IN" },
  { name: "Pune, IN", city: "Pune", country: "IN" },
  { name: "Jaipur, IN", city: "Jaipur", country: "IN" },
  { name: "Lucknow, IN", city: "Lucknow", country: "IN" },
  { name: "Kanpur, IN", city: "Kanpur", country: "IN" },
  { name: "Nagpur, IN", city: "Nagpur", country: "IN" },
  { name: "Indore, IN", city: "Indore", country: "IN" },
  { name: "Thane, IN", city: "Thane", country: "IN" },
  { name: "Bhopal, IN", city: "Bhopal", country: "IN" },
  { name: "Visakhapatnam, IN", city: "Visakhapatnam", country: "IN" },
  { name: "Pimpri-Chinchwad, IN", city: "Pimpri-Chinchwad", country: "IN" },
  { name: "Patna, IN", city: "Patna", country: "IN" },
  { name: "Vadodara, IN", city: "Vadodara", country: "IN" },
  { name: "Ghaziabad, IN", city: "Ghaziabad", country: "IN" },
  { name: "Ludhiana, IN", city: "Ludhiana", country: "IN" },
  { name: "Agra, IN", city: "Agra", country: "IN" },
  { name: "Nashik, IN", city: "Nashik", country: "IN" },
  { name: "Faridabad, IN", city: "Faridabad", country: "IN" },
  { name: "Meerut, IN", city: "Meerut", country: "IN" },
  { name: "Rajkot, IN", city: "Rajkot", country: "IN" },
  { name: "Kalyan-Dombivali, IN", city: "Kalyan-Dombivali", country: "IN" },
  { name: "Vasai-Virar, IN", city: "Vasai-Virar", country: "IN" },
  { name: "Varanasi, IN", city: "Varanasi", country: "IN" },
  { name: "Srinagar, IN", city: "Srinagar", country: "IN" },
  { name: "Aurangabad, IN", city: "Aurangabad", country: "IN" },
  { name: "Dhanbad, IN", city: "Dhanbad", country: "IN" },
  { name: "Amritsar, IN", city: "Amritsar", country: "IN" },
  { name: "Navi Mumbai, IN", city: "Navi Mumbai", country: "IN" },
  { name: "Allahabad, IN", city: "Allahabad", country: "IN" },
  { name: "Ranchi, IN", city: "Ranchi", country: "IN" },
  { name: "Howrah, IN", city: "Howrah", country: "IN" },
  { name: "Coimbatore, IN", city: "Coimbatore", country: "IN" },
  { name: "Jabalpur, IN", city: "Jabalpur", country: "IN" },
  { name: "Gwalior, IN", city: "Gwalior", country: "IN" },
  { name: "Vijayawada, IN", city: "Vijayawada", country: "IN" },
  { name: "Jodhpur, IN", city: "Jodhpur", country: "IN" },
  { name: "Madurai, IN", city: "Madurai", country: "IN" },
  { name: "Raipur, IN", city: "Raipur", country: "IN" },
  { name: "Kota, IN", city: "Kota", country: "IN" },
  { name: "Chandigarh, IN", city: "Chandigarh", country: "IN" },

  { name: "Karachi, PK", city: "Karachi", country: "PK" },
  { name: "Lahore, PK", city: "Lahore", country: "PK" },
  { name: "Faisalabad, PK", city: "Faisalabad", country: "PK" },
  { name: "Rawalpindi, PK", city: "Rawalpindi", country: "PK" },
  { name: "Gujranwala, PK", city: "Gujranwala", country: "PK" },
  { name: "Peshawar, PK", city: "Peshawar", country: "PK" },
  { name: "Multan, PK", city: "Multan", country: "PK" },
  { name: "Hyderabad, PK", city: "Hyderabad", country: "PK" },
  { name: "Islamabad, PK", city: "Islamabad", country: "PK" },
  { name: "Quetta, PK", city: "Quetta", country: "PK" },
  { name: "Bahawalpur, PK", city: "Bahawalpur", country: "PK" },
  { name: "Sargodha, PK", city: "Sargodha", country: "PK" },
  { name: "Sialkot, PK", city: "Sialkot", country: "PK" },
  { name: "Sukkur, PK", city: "Sukkur", country: "PK" },
  { name: "Larkana, PK", city: "Larkana", country: "PK" },

  { name: "Dhaka, BD", city: "Dhaka", country: "BD" },
  { name: "Chittagong, BD", city: "Chittagong", country: "BD" },
  { name: "Khulna, BD", city: "Khulna", country: "BD" },
  { name: "Rajshahi, BD", city: "Rajshahi", country: "BD" },
  { name: "Sylhet, BD", city: "Sylhet", country: "BD" },
  { name: "Comilla, BD", city: "Comilla", country: "BD" },
  { name: "Rangpur, BD", city: "Rangpur", country: "BD" },
  { name: "Barisal, BD", city: "Barisal", country: "BD" },
  { name: "Mymensingh, BD", city: "Mymensingh", country: "BD" },
  { name: "Narayanganj, BD", city: "Narayanganj", country: "BD" },

  { name: "Kathmandu, NP", city: "Kathmandu", country: "NP" },
  { name: "Pokhara, NP", city: "Pokhara", country: "NP" },
  { name: "Lalitpur, NP", city: "Lalitpur", country: "NP" },
  { name: "Bharatpur, NP", city: "Bharatpur", country: "NP" },
  { name: "Biratnagar, NP", city: "Biratnagar", country: "NP" },
  { name: "Birgunj, NP", city: "Birgunj", country: "NP" },

  // Middle East
  { name: "Dubai, AE", city: "Dubai", country: "AE" },
  { name: "Abu Dhabi, AE", city: "Abu Dhabi", country: "AE" },
  { name: "Sharjah, AE", city: "Sharjah", country: "AE" },
  { name: "Al Ain, AE", city: "Al Ain", country: "AE" },
  { name: "Ajman, AE", city: "Ajman", country: "AE" },
  { name: "Ras Al Khaimah, AE", city: "Ras Al Khaimah", country: "AE" },
  { name: "Fujairah, AE", city: "Fujairah", country: "AE" },

  { name: "Riyadh, SA", city: "Riyadh", country: "SA" },
  { name: "Jeddah, SA", city: "Jeddah", country: "SA" },
  { name: "Mecca, SA", city: "Mecca", country: "SA" },
  { name: "Medina, SA", city: "Medina", country: "SA" },
  { name: "Dammam, SA", city: "Dammam", country: "SA" },
  { name: "Khobar, SA", city: "Khobar", country: "SA" },
  { name: "Tabuk, SA", city: "Tabuk", country: "SA" },
  { name: "Abha, SA", city: "Abha", country: "SA" },
  { name: "Khamis Mushait, SA", city: "Khamis Mushait", country: "SA" },
  { name: "Hail, SA", city: "Hail", country: "SA" },
  { name: "Jubail, SA", city: "Jubail", country: "SA" },
  { name: "Najran, SA", city: "Najran", country: "SA" },
  { name: "Yanbu, SA", city: "Yanbu", country: "SA" },

  { name: "Doha, QA", city: "Doha", country: "QA" },
  { name: "Al Rayyan, QA", city: "Al Rayyan", country: "QA" },
  { name: "Umm Salal, QA", city: "Umm Salal", country: "QA" },
  { name: "Al Wakrah, QA", city: "Al Wakrah", country: "QA" },

  { name: "Muscat, OM", city: "Muscat", country: "OM" },
  { name: "Seeb, OM", city: "Seeb", country: "OM" },
  { name: "Salalah, OM", city: "Salalah", country: "OM" },
  { name: "Bawshar, OM", city: "Bawshar", country: "OM" },
  { name: "Sohar, OM", city: "Sohar", country: "OM" },
  { name: "Sur, OM", city: "Sur", country: "OM" },

  { name: "Tehran, IR", city: "Tehran", country: "IR" },
  { name: "Mashhad, IR", city: "Mashhad", country: "IR" },
  { name: "Isfahan, IR", city: "Isfahan", country: "IR" },
  { name: "Karaj, IR", city: "Karaj", country: "IR" },
  { name: "Tabriz, IR", city: "Tabriz", country: "IR" },
  { name: "Shiraz, IR", city: "Shiraz", country: "IR" },
  { name: "Qom, IR", city: "Qom", country: "IR" },
  { name: "Ahvaz, IR", city: "Ahvaz", country: "IR" },
  { name: "Kermanshah, IR", city: "Kermanshah", country: "IR" },
  { name: "Urmia, IR", city: "Urmia", country: "IR" },
  { name: "Rasht, IR", city: "Rasht", country: "IR" },
  { name: "Zahedan, IR", city: "Zahedan", country: "IR" },
  { name: "Hamadan, IR", city: "Hamadan", country: "IR" },
  { name: "Kerman, IR", city: "Kerman", country: "IR" },
  { name: "Yazd, IR", city: "Yazd", country: "IR" },

  { name: "Baghdad, IQ", city: "Baghdad", country: "IQ" },
  { name: "Basra, IQ", city: "Basra", country: "IQ" },
  { name: "Mosul, IQ", city: "Mosul", country: "IQ" },
  { name: "Erbil, IQ", city: "Erbil", country: "IQ" },
  { name: "Abu Ghraib, IQ", city: "Abu Ghraib", country: "IQ" },
  { name: "Kirkuk, IQ", city: "Kirkuk", country: "IQ" },
  { name: "Najaf, IQ", city: "Najaf", country: "IQ" },
  { name: "Karbala, IQ", city: "Karbala", country: "IQ" },
  { name: "Nasiriyah, IQ", city: "Nasiriyah", country: "IQ" },
  { name: "Amarah, IQ", city: "Amarah", country: "IQ" },

  { name: "Jerusalem, IL", city: "Jerusalem", country: "IL" },
  { name: "Tel Aviv, IL", city: "Tel Aviv", country: "IL" },
  { name: "Haifa, IL", city: "Haifa", country: "IL" },
  { name: "Rishon LeZion, IL", city: "Rishon LeZion", country: "IL" },
  { name: "Petah Tikva, IL", city: "Petah Tikva", country: "IL" },
  { name: "Ashdod, IL", city: "Ashdod", country: "IL" },
  { name: "Netanya, IL", city: "Netanya", country: "IL" },
  { name: "Beer Sheva, IL", city: "Beer Sheva", country: "IL" },
  { name: "Bnei Brak, IL", city: "Bnei Brak", country: "IL" },
  { name: "Holon, IL", city: "Holon", country: "IL" },

  { name: "Amman, JO", city: "Amman", country: "JO" },
  { name: "Zarqa, JO", city: "Zarqa", country: "JO" },
  { name: "Irbid, JO", city: "Irbid", country: "JO" },
  { name: "Russeifa, JO", city: "Russeifa", country: "JO" },
  { name: "Wadi as-Sir, JO", city: "Wadi as-Sir", country: "JO" },
  { name: "Aqaba, JO", city: "Aqaba", country: "JO" },
  { name: "Madaba, JO", city: "Madaba", country: "JO" },
  { name: "As-Salt, JO", city: "As-Salt", country: "JO" },

  // Africa
  { name: "Cairo, EG", city: "Cairo", country: "EG" },
  { name: "Alexandria, EG", city: "Alexandria", country: "EG" },
  { name: "Giza, EG", city: "Giza", country: "EG" },
  { name: "Shubra El Kheima, EG", city: "Shubra El Kheima", country: "EG" },
  { name: "Port Said, EG", city: "Port Said", country: "EG" },
  { name: "Suez, EG", city: "Suez", country: "EG" },
  { name: "Luxor, EG", city: "Luxor", country: "EG" },
  { name: "Mansoura, EG", city: "Mansoura", country: "EG" },
  {
    name: "El Mahalla El Kubra, EG",
    city: "El Mahalla El Kubra",
    country: "EG",
  },
  { name: "Tanta, EG", city: "Tanta", country: "EG" },
  { name: "Aswan, EG", city: "Aswan", country: "EG" },
  { name: "Ismailia, EG", city: "Ismailia", country: "EG" },
  { name: "Fayyum, EG", city: "Fayyum", country: "EG" },
  { name: "Zagazig, EG", city: "Zagazig", country: "EG" },
  { name: "Assiut, EG", city: "Assiut", country: "EG" },

  { name: "Lagos, NG", city: "Lagos", country: "NG" },
  { name: "Kano, NG", city: "Kano", country: "NG" },
  { name: "Ibadan, NG", city: "Ibadan", country: "NG" },
  { name: "Abuja, NG", city: "Abuja", country: "NG" },
  { name: "Port Harcourt, NG", city: "Port Harcourt", country: "NG" },
  { name: "Benin City, NG", city: "Benin City", country: "NG" },
  { name: "Maiduguri, NG", city: "Maiduguri", country: "NG" },
  { name: "Zaria, NG", city: "Zaria", country: "NG" },
  { name: "Aba, NG", city: "Aba", country: "NG" },
  { name: "Jos, NG", city: "Jos", country: "NG" },
  { name: "Ilorin, NG", city: "Ilorin", country: "NG" },
  { name: "Oyo, NG", city: "Oyo", country: "NG" },
  { name: "Enugu, NG", city: "Enugu", country: "NG" },
  { name: "Abeokuta, NG", city: "Abeokuta", country: "NG" },
  { name: "Kaduna, NG", city: "Kaduna", country: "NG" },

  { name: "Accra, GH", city: "Accra", country: "GH" },
  { name: "Kumasi, GH", city: "Kumasi", country: "GH" },
  { name: "Tamale, GH", city: "Tamale", country: "GH" },
  { name: "Sekondi-Takoradi, GH", city: "Sekondi-Takoradi", country: "GH" },
  { name: "Ashaiman, GH", city: "Ashaiman", country: "GH" },
  { name: "Tema, GH", city: "Tema", country: "GH" },
  { name: "Teshie, GH", city: "Teshie", country: "GH" },
  { name: "Cape Coast, GH", city: "Cape Coast", country: "GH" },
  { name: "Obuasi, GH", city: "Obuasi", country: "GH" },
  { name: "Sunyani, GH", city: "Sunyani", country: "GH" },

  { name: "Nairobi, KE", city: "Nairobi", country: "KE" },
  { name: "Mombasa, KE", city: "Mombasa", country: "KE" },
  { name: "Nakuru, KE", city: "Nakuru", country: "KE" },
  { name: "Eldoret, KE", city: "Eldoret", country: "KE" },
  { name: "Kisumu, KE", city: "Kisumu", country: "KE" },
  { name: "Thika, KE", city: "Thika", country: "KE" },
  { name: "Malindi, KE", city: "Malindi", country: "KE" },
  { name: "Kitale, KE", city: "Kitale", country: "KE" },
  { name: "Machakos, KE", city: "Machakos", country: "KE" },
  { name: "Meru, KE", city: "Meru", country: "KE" },

  { name: "Addis Ababa, ET", city: "Addis Ababa", country: "ET" },
  { name: "Dire Dawa, ET", city: "Dire Dawa", country: "ET" },
  { name: "Mek'ele, ET", city: "Mek'ele", country: "ET" },
  { name: "Gondar, ET", city: "Gondar", country: "ET" },
  { name: "Adama, ET", city: "Adama", country: "ET" },
  { name: "Awassa, ET", city: "Awassa", country: "ET" },
  { name: "Bahir Dar, ET", city: "Bahir Dar", country: "ET" },
  { name: "Dessie, ET", city: "Dessie", country: "ET" },
  { name: "Jimma, ET", city: "Jimma", country: "ET" },
  { name: "Jijiga, ET", city: "Jijiga", country: "ET" },

  { name: "Johannesburg, ZA", city: "Johannesburg", country: "ZA" },
  { name: "Cape Town, ZA", city: "Cape Town", country: "ZA" },
  { name: "Durban, ZA", city: "Durban", country: "ZA" },
  { name: "Pretoria, ZA", city: "Pretoria", country: "ZA" },
  { name: "Port Elizabeth, ZA", city: "Port Elizabeth", country: "ZA" },
  { name: "Pietermaritzburg, ZA", city: "Pietermaritzburg", country: "ZA" },
  { name: "Benoni, ZA", city: "Benoni", country: "ZA" },
  { name: "Tembisa, ZA", city: "Tembisa", country: "ZA" },
  { name: "East London, ZA", city: "East London", country: "ZA" },
  { name: "Vereeniging, ZA", city: "Vereeniging", country: "ZA" },
  { name: "Bloemfontein, ZA", city: "Bloemfontein", country: "ZA" },
  { name: "Boksburg, ZA", city: "Boksburg", country: "ZA" },
  { name: "Welkom, ZA", city: "Welkom", country: "ZA" },
  { name: "Newcastle, ZA", city: "Newcastle", country: "ZA" },
  { name: "Krugersdorp, ZA", city: "Krugersdorp", country: "ZA" },

  { name: "Casablanca, MA", city: "Casablanca", country: "MA" },
  { name: "Rabat, MA", city: "Rabat", country: "MA" },
  { name: "Fes, MA", city: "Fes", country: "MA" },
  { name: "Sale, MA", city: "Sale", country: "MA" },
  { name: "Marrakech, MA", city: "Marrakech", country: "MA" },
  { name: "Agadir, MA", city: "Agadir", country: "MA" },
  { name: "Tangier, MA", city: "Tangier", country: "MA" },
  { name: "Meknes, MA", city: "Meknes", country: "MA" },
  { name: "Oujda, MA", city: "Oujda", country: "MA" },
  { name: "Kenitra, MA", city: "Kenitra", country: "MA" },
  { name: "Tetouan, MA", city: "Tetouan", country: "MA" },

  { name: "Tunis, TN", city: "Tunis", country: "TN" },
  { name: "Sfax, TN", city: "Sfax", country: "TN" },
  { name: "Sousse, TN", city: "Sousse", country: "TN" },
  { name: "Ettadhamen, TN", city: "Ettadhamen", country: "TN" },
  { name: "Kairouan, TN", city: "Kairouan", country: "TN" },
  { name: "Bizerte, TN", city: "Bizerte", country: "TN" },
  { name: "Gabes, TN", city: "Gabes", country: "TN" },
  { name: "Ariana, TN", city: "Ariana", country: "TN" },

  { name: "Algiers, DZ", city: "Algiers", country: "DZ" },
  { name: "Oran, DZ", city: "Oran", country: "DZ" },
  { name: "Constantine, DZ", city: "Constantine", country: "DZ" },
  { name: "Annaba, DZ", city: "Annaba", country: "DZ" },
  { name: "Blida, DZ", city: "Blida", country: "DZ" },
  { name: "Batna, DZ", city: "Batna", country: "DZ" },
  { name: "Djelfa, DZ", city: "Djelfa", country: "DZ" },
  { name: "Setif, DZ", city: "Setif", country: "DZ" },
  { name: "Sidi Bel Abbes, DZ", city: "Sidi Bel Abbes", country: "DZ" },
  { name: "Biskra, DZ", city: "Biskra", country: "DZ" },

  // Oceania
  { name: "Sydney, AU", city: "Sydney", country: "AU" },
  { name: "Melbourne, AU", city: "Melbourne", country: "AU" },
  { name: "Brisbane, AU", city: "Brisbane", country: "AU" },
  { name: "Perth, AU", city: "Perth", country: "AU" },
  { name: "Adelaide, AU", city: "Adelaide", country: "AU" },
  { name: "Gold Coast, AU", city: "Gold Coast", country: "AU" },
  { name: "Newcastle, AU", city: "Newcastle", country: "AU" },
  { name: "Canberra, AU", city: "Canberra", country: "AU" },
  { name: "Sunshine Coast, AU", city: "Sunshine Coast", country: "AU" },
  { name: "Wollongong, AU", city: "Wollongong", country: "AU" },
  { name: "Hobart, AU", city: "Hobart", country: "AU" },
  { name: "Geelong, AU", city: "Geelong", country: "AU" },
  { name: "Townsville, AU", city: "Townsville", country: "AU" },
  { name: "Cairns, AU", city: "Cairns", country: "AU" },
  { name: "Darwin, AU", city: "Darwin", country: "AU" },
  { name: "Toowoomba, AU", city: "Toowoomba", country: "AU" },
  { name: "Ballarat, AU", city: "Ballarat", country: "AU" },
  { name: "Bendigo, AU", city: "Bendigo", country: "AU" },
  { name: "Albury, AU", city: "Albury", country: "AU" },
  { name: "Launceston, AU", city: "Launceston", country: "AU" },
  { name: "Mackay, AU", city: "Mackay", country: "AU" },
  { name: "Rockhampton, AU", city: "Rockhampton", country: "AU" },
  { name: "Bunbury, AU", city: "Bunbury", country: "AU" },
  { name: "Bundaberg, AU", city: "Bundaberg", country: "AU" },
  { name: "Hervey Bay, AU", city: "Hervey Bay", country: "AU" },
  { name: "Wagga Wagga, AU", city: "Wagga Wagga", country: "AU" },
  { name: "Mildura, AU", city: "Mildura", country: "AU" },
  { name: "Shepparton, AU", city: "Shepparton", country: "AU" },
  { name: "Port Macquarie, AU", city: "Port Macquarie", country: "AU" },
  { name: "Gladstone, AU", city: "Gladstone", country: "AU" },

  { name: "Auckland, NZ", city: "Auckland", country: "NZ" },
  { name: "Wellington, NZ", city: "Wellington", country: "NZ" },
  { name: "Christchurch, NZ", city: "Christchurch", country: "NZ" },
  { name: "Hamilton, NZ", city: "Hamilton", country: "NZ" },
  { name: "Napier-Hastings, NZ", city: "Napier-Hastings", country: "NZ" },
  { name: "Dunedin, NZ", city: "Dunedin", country: "NZ" },
  { name: "Palmerston North, NZ", city: "Palmerston North", country: "NZ" },
  { name: "Nelson, NZ", city: "Nelson", country: "NZ" },
  { name: "Rotorua, NZ", city: "Rotorua", country: "NZ" },
  { name: "New Plymouth, NZ", city: "New Plymouth", country: "NZ" },
  { name: "Whangarei, NZ", city: "Whangarei", country: "NZ" },
  { name: "Invercargill, NZ", city: "Invercargill", country: "NZ" },
  { name: "Wanganui, NZ", city: "Wanganui", country: "NZ" },
  { name: "Gisborne, NZ", city: "Gisborne", country: "NZ" },
  { name: "Timaru, NZ", city: "Timaru", country: "NZ" },
];

export default RANDOM_CITIES;
